import { RefObject, useEffect, useState } from 'react';

export const useHeaderShadow = (elementRef: RefObject<HTMLElement>) => {
  const [hasHeaderShadow, setHasHeaderShadow] = useState(false);

  useEffect(() => {
    const element = elementRef.current;

    if (!element) {
      return;
    }

    const handleScroll = () => {
      setHasHeaderShadow(element.scrollTop > 0);
    };

    element.addEventListener('scroll', handleScroll);

    return () => element.removeEventListener('scroll', handleScroll);
  }, [elementRef.current]);

  return hasHeaderShadow;
};
